import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AuthUIRouter} from '@ngx-ivengi/auth-ui-router';
import {CleanzoneModule} from '@ngx-ivengi/cleanzone';
import {LocaleModule, LocaleService} from '@ngx-ivengi/locale';
import {AuthenticationModule} from '@ngx-ivengi/authentication';
import {FormsModule} from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ToastModule} from 'ng2-toastr';
import {BsDatepickerModule, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {defineLocale} from 'ngx-bootstrap/bs-moment';
import {nl} from 'ngx-bootstrap/locale';


import {AppRoutingModule} from './app.routes';
import {AppComponent} from './app.component';
import {ConfigModule} from './components/config/config.module';
import {DashboardModule} from './components/dashboard/dashboard.module';
import {MaintenanceModule} from './components/maintenance/maintenance.module';
import { RequestPathInterceptor } from './components/shared/request-path.interceptor';
import {UserModule} from './components/user/user.module';
import {BuildingModule} from './components/building/building.module';
import {CustomerModule} from './components/customer/customer.module';
import {AssignmentModule} from './components/assignment/assignment.module';
import {FloorModule} from './components/floor/floor.module';
import {OwnerModule} from './components/owner/owner.module';
import {ContactModule} from './components/contact/contact.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {UnauthorizedModule} from './components/unauthorized/unauthorized.module';
import {RoomModule} from './components/room/room.module';
import {ManagementModule} from './components/management/management.module';
import {DrawingModule} from './components/drawing/drawing.module';
import {ProductModule} from './components/product/product.module';
import {EnumerationModule} from './components/enumeration/enumeration.module';
import {DeviceModule} from './components/device/device.module';
import {ReportModule} from './components/report/report.module';
import {UIRouterModule} from '@uirouter/angular';
import {RoutingModule} from './components/routing/routing.module';
import {ChargeModule} from './components/charge/charge.module';
import {PriceModule} from './components/price/price.module';
import {ChannelModule} from './components/channel/channel.module';
import {PictureModule} from './components/picture/picture.module';
import {ExportationModule} from './components/exportation/exportation.module';
import {ThroughputModule} from './components/throughput/throughput.module';
import {ArchiveModule} from './components/archive/archive.module';
import {DatagridModule} from './components/datagrid/datagrid.module';
import {environment} from '../environments/environment';
import {ProfileModule} from './components/profile/profile.module';
import {WarrantyModule} from './components/warranty/warranty.module';
import {LoginComponent} from './components/login/login.component';
import { CalculationModule } from './components/calculation/calculation.module';

LocaleService.setDefaultLanguageISO('nl-NL');
LocaleService.setAvailableLanguageISO(['nl-NL', 'en-US']);


declare function require(url: string);
require('assets/i18n/nl-NL.json');
require('assets/i18n/routes.json');

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    BrowserModule,
    UIRouterModule.forRoot({
      otherwise: 'dashboard'
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    AuthenticationModule,
    AuthUIRouter,
    BrowserAnimationsModule,
    ToastModule.forRoot(),
    ConfigModule,
    FormsModule,
    HttpModule,
    CleanzoneModule,
    UnauthorizedModule,
    DashboardModule,
    UserModule,
    ProfileModule,
    BuildingModule,
    FloorModule,
    RoomModule,
    DrawingModule,
    CustomerModule,
    AssignmentModule,
    OwnerModule,
    ContactModule,
    ManagementModule,
    ProductModule,
    EnumerationModule,
    ProductModule,
    DeviceModule,
    ReportModule,
    ChargeModule,
    PriceModule,
    ChannelModule,
    PictureModule,
    ThroughputModule,
    ExportationModule,
    AppRoutingModule,
    RoutingModule,
    LocaleModule,
    ArchiveModule,
    BsDatepickerModule.forRoot(),
    DatagridModule,
    MaintenanceModule,
    WarrantyModule,
    CalculationModule,
  ],
  declarations: [
    AppComponent,
    LoginComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: RequestPathInterceptor, multi: true,
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(
    private bootstrapLocaleService: BsLocaleService
  ) {
    defineLocale('nl', nl);
    this.bootstrapLocaleService.use('nl');
  }
}




// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/app.module.ts